import EventDescription from './EventDescription';
import EventCover from './Cover';
import BottomBar from './BottomBar';
import BottomLogos from './BottomLogos';

export { EventDescription, EventCover, BottomBar, BottomLogos };
